/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum PncDoneFilterEnum {
    DONE = 'DONE',
    UNDONE = 'UNDONE',

}
